import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Hook to automatically track page views on route changes
 * Must be used inside a Router context
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Small delay to ensure document title has been updated by SEOHead
    const timer = setTimeout(() => {
      const title = document.title;
      trackPageView(location.pathname, title);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);
};
